import { emptyCellCharacter } from "../../types.js";
function getGridEmptyValue(row) {
  return row.is_summary === true ? null : emptyCellCharacter;
}
export {
  getGridEmptyValue
};
//# sourceMappingURL=utils.js.map
